export default __webpack_public_path__ + "static/media/quiz_bg_mobile.fb49fa7b.png";